"use client";

import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { isBoardPath } from "@/lib/layout/shell";

/**
 * Board v3 shell: no left sidebar on any page, so nothing is offset. Board
 * pages run edge to edge; every other page keeps the centred 1280px container.
 * See lib/layout/shell.ts.
 */
export function MainShell({ children }: { children: React.ReactNode }) {
  return <div className="min-h-screen overflow-x-clip bg-background">{children}</div>;
}

export function MainContent({ children }: { children: React.ReactNode }) {
  const board = isBoardPath(usePathname());
  return (
    // Bottom padding last: cn() merges conflicting classes and py-* would
    // otherwise drop the room kept for the phone bottom bar.
    <main className={cn(board ? "w-full px-3 py-3" : "container py-6", "pb-[104px] lg:pb-6")}>
      {children}
    </main>
  );
}
